import React from 'react'
import { THE_FULL_SIZE_ITEMS_YOU_VE_SAMPLED_URL } from 'modules/full-size-items-you-ve-sampled/constants'

import { useMediaQuery } from '@mui/material'
import useDispatch from 'hooks/use-dispatch'
import loadSampleHistoryCustomerAction from 'modules/customer/redux/actions/load-sample-history'
import useSelector from 'hooks/use-selector'
import getSampleHistoryQuestionsCustomerSelect from 'modules/customer/redux/selectors/get-sample-history-questions'

// import hasSampledProductAction from 'modules/product/redux/actions/has-sampled'
import loadByIdDeepProductVariantAction from 'modules/product-variant/redux/actions/load-by-id-deep'
import logUtil from 'utils/log'
import ProductSlider from 'components/ProductSlider'
import QuestionProduct from 'components/QuestionProduct'
import navigateToUrlLocationUtil from 'utils/location/navigate-to-url'

const TITLE_MOBILE = 'The items you’ve sampled'
const TITLE_DESKTOP = 'Get the full size of items you’ve sampled'
const SEE_ALL = 'See all'
const ANALYTIC_EVENT_PREFIX = 'FULL_SIZE_ITEMS_YOU_VE_SAMPLED'

export default function FullSizeItemsYouVeSampledSlider (props) {
  const currentProductVariant = props?.productVariant
  let questions = useSelector(getSampleHistoryQuestionsCustomerSelect)
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('md'))
  const dispatch = useDispatch()

  if (currentProductVariant && questions?.length > 0) {
    questions = questions?.filter(question => question.product_id !== Number(currentProductVariant?.product_id))
  }

  const loadSampleHistory = async () => {
    try {
      const res = await dispatch(
        loadSampleHistoryCustomerAction({
          query: {
            page_size: 12
          }
        })
      )
      logUtil('FullSizeItemsYouVeSampledSlider#loadSampleHistoryAction').debug('[done]')
      return res
    } catch (error) {
      logUtil('FullSizeItemsYouVeSampledSlider#loadSampleHistoryAction').debug('error: ', error)
    }
  }

  /**
   * loading deep product here because questions don't have enough
   * information about in stock status, etc.
   */
  const loadVariantsDeep = async (variantIds) => {
    await Promise.all(
      variantIds?.map(async (variantId) => {
        await dispatch(loadByIdDeepProductVariantAction(variantId))
      })
    )
  }

  React.useEffect(() => {
    if (questions?.length > 0) {
      const productIds = questions.map(question => question.fullsize_variant_id)
      // dispatch(hasSampledProductAction({ productIds }))
      loadVariantsDeep(productIds)
    }
  }, [questions])

  const handleClickTitleOrShopAll = (event) => {
    event.preventDefault()
    navigateToUrlLocationUtil(THE_FULL_SIZE_ITEMS_YOU_VE_SAMPLED_URL)
  }

  const itemProps = {
    isQuestionProduct: true
  }

  return (
    <section className='full-size-items-you-ve-sampled-slider'>
      <ProductSlider
        title={isSmallScreen ? TITLE_MOBILE : TITLE_DESKTOP}
        shopAllLabel={SEE_ALL}
        products={questions}
        loadProducts={loadSampleHistory}
        href={THE_FULL_SIZE_ITEMS_YOU_VE_SAMPLED_URL}
        analyticEventPrefix={ANALYTIC_EVENT_PREFIX}
        onClickTitleOrShopAll={handleClickTitleOrShopAll}
        ProductCollectionItemComponent={QuestionProduct}
        itemProps={itemProps}
        loadImmediately={props?.loadImmediately}
      />
    </section>
  )
}
